import { Button } from '@repo/shared-client/components/ui'
import { Link } from '@tanstack/react-router'
import LogoSymbol from '@web/src/components/primatives/logo-symbol/logo-symbol'
import { useTranslation } from '@web/src/lib/intl/react'
import { ArrowLeftIcon, HomeIcon } from 'lucide-react'
import Footer from '../footer/footer'
import MainNavBar from '../main-nav-bar/main-nav-bar'

const NotFoundPage = () => {
  const { t } = useTranslation()

  return (
    <>
      <MainNavBar />

      <div className="mx-auto w-full max-w-5xl pt-6 pb-20">
        <div className="flex flex-col items-center justify-center gap-6">
          <div className="flex items-center gap-2">
            <span className="flex items-center font-bold text-8xl leading-none sm:text-9xl">4</span>
            <LogoSymbol imageClassName="w-[90px] drop-shadow(1px 2px 1px #000000)" />
            <span className="flex items-center font-bold text-8xl leading-none sm:text-9xl">4</span>
          </div>

          <div className="flex flex-col gap-4 text-center">
            <h1 className="font-semibold text-4xl text-foreground tracking-tight">{t('Page Not Found')}</h1>
            <p className="mx-auto max-w-lg text-muted-foreground text-xl">
              {t('Oops! It looks like there are no Spicy Friends here.')}
            </p>
          </div>

          <div className="w-full pt-6">
            <div className="flex flex-col items-center justify-center gap-4 md:flex-row">
              <Button className="w-full md:w-auto" nativeButton={false} render={<Link to="/" />} size="lg">
                <HomeIcon aria-hidden />
                {t('Back to Home')}
              </Button>
              <Button className="w-full md:w-auto" onClick={() => window.history.back()} size="lg" variant="outline">
                <ArrowLeftIcon aria-hidden />
                {t('Go Back')}
              </Button>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  )
}

export default NotFoundPage
